import { render, staticRenderFns } from "./cModalProcInvasivoView.vue?vue&type=template&id=4a2c5138"
import script from "./cModalProcInvasivoView.vue?vue&type=script&lang=js"
export * from "./cModalProcInvasivoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports